import { Icon, Intent } from "@blueprintjs/core"
import { ID } from "src/libs/interfaces/layouts"
import { PETestQuestion } from "src/modules/pe-tests-module/data/interfaces"
import { ITestsStore, useTestsStore } from "src/modules/pe-tests-module/data/store"

/* Protopia Ecosystem component */
export interface IMultiChoiceListResultProps {
    item: PETestQuestion
    i:number
}
const MultiChoiceListResult = ({item, i, ...props}: IMultiChoiceListResultProps): JSX.Element => { 
    const results: ID[]   = useTestsStore((state:ITestsStore) => state.results)
    return <div className="row strob01 py-2" >
        <div className="col-md-6">{item.title}</div>
        <div className="col-md-1">
        <Icon
            icon={  item.right_answer_id === results[i] ? "tick" : "cross"}
            intent={item.right_answer_id === results[i] ? Intent.SUCCESS : Intent.DANGER}
        />
        </div>
        <div className="col-md-5 small ">
        {
            item.answers.filter(a => a.id === item.right_answer_id)[0]?.title
        }
        </div>
    </div>
}
export default MultiChoiceListResult